export const defaultTemporaryBrowsingState = {
    cxmFilmsForComponent: {}
};
